import React from 'react';
import '../../styles/sections/Pricing.css';

function Pricing() {
  return (
    <section id="pricing" className="pricing">
      <div className="pricing-content">
        <h2>Simple, Transparent Pricing</h2>
        <div className="pricing-options">
          <div className="pricing-card">
            <h3>Standard Shipping</h3>
            <div className="price">$19.99 AUD</div>
            <p>Delivered in 5-7 days</p>
            <ul>
              <li>High-quality ceramic tile</li>
              <li>Custom photo printing</li>
              <li>Letter post with tracking</li>
            </ul>
          </div>
          <div className="pricing-card featured">
            <h3>Express Shipping</h3>
            <div className="price">$24.99 AUD</div>
            <p>Delivered in 2-4 days</p>
            <ul>
              <li>High-quality ceramic tile</li>
              <li>Custom photo printing</li>
              <li>Express shipping with tracking</li>
            </ul>
          </div>
        </div>
        <p className="pricing-note">All prices in Australian Dollars (AUD). Images are stored securely and deleted after 3 months.</p>
      </div>
    </section>
  );
}

export default Pricing; 